import { render, staticRenderFns } from "./TopbarSubItem.vue?vue&type=template&id=04deef6b"
import script from "./TopbarSubItem.vue?vue&type=script&lang=js"
export * from "./TopbarSubItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports